<section>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">Home</li>
      <li class="breadcrumb-item">Vendors</li>
      <li class="breadcrumb-item active">Vendor Profile Status</li>
    </ol>
  </section>
  <section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><i class="fas fa-search mr-1"></i> Vendor Profile Status </span>                       
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>
  <section>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="devcare-card-body">
                  <div class="row">
                      <div class="col-md-12">
                         
                      </div>
                  </div>
                  <div class="row" *ngIf="showTopFilters">
                      <div class="col-md-10">
                          <div class="p-fluid p-formgrid p-grid">
                             
                          </div>
                      </div>
                      <div class="col-md-2 d-flex align-items-center">
                         
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-4">
                          <button [ngClass] = "showSorting === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'" pButton type="button" icon="pi pi-fw pi-sort-alt" (click)="bindShowSorting()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                          <button [ngClass] = "showFilters === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="fas fa-filter" (click)="bindShowFilter()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                          <button [ngClass] = "showToggle === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="pi pi-list" (click)="bindShowToggle()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                      </div>
                      <div class="col-md-8">

                        <button pButton label="Export" class="p-button-raised  m-2" icon="pi pi-file-excel" type="button" 
                        style="float: right;height: 30px;" (click)="exportVendorProfileStatus()"
                         ></button>
                          
                           <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash" (click)="clearFilter(dt2)" 
                          style="float: right;height: 30px;"></button>
                          

                      </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="row">
        <div class="col-md-12">
            <div class="card">               
                <div class="devcare-table-card-header" *ngIf="showToggle">
                    <div class="row">
                        <div class="col-md-6">
    
                        </div>
                        <div class="col-md-6">
                        <p-multiSelect *ngIf="showToggle" [options]="allColumns" [(ngModel)]="selectedColumns" maxSelectedLabels="0" dropdownIcon="pi pi-list" selectedItemsLabel="{0} columns selected" optionLabel="header" [showHeader] = "false" [showClear]="false" (onChange)="showAndHideColumn($event)" style="float: right;">
                            <ng-template let-column pTemplate="item">
                                <div class="column-item">
                                    <div>{{column.header}}</div>
                                </div>
                            </ng-template>
                        </p-multiSelect>
                        </div>
                    </div>
                </div>
           
            <div class="card-body devcare-table-card-body" style="overflow: hidden;">
                <p-table #dt2 [value]="vendorProfileStatusList" dataKey="id" [rows]="10" [sortOrder]="0"
                [lazy]="true" (onLazyLoad)="loadVendorProfileStatusList($event)"
                paginatorDropdownAppendTo="body" [showCurrentPageReport]="true" [resizableColumns]="true"
                columnResizeMode="expand" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
                styleClass="p-datatable-gridlines" [paginator]="isshowpaginator" [totalRecords]="totalRecords"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [globalFilterFields]="['companyName', 'adminName', 'adminEmail','adminPhone','companyProfile','companyDetails','deliveryTeams','reference','adminDetails','onboardDocuments','createdOn', 'modifiedOn','createdByName']">
                <ng-template pTemplate="header">
                    <tr>
                        <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}"
                            *ngIf="isShowColumns('companyName')">Vendor<span pSortableColumn="companyName"
                                *ngIf="showSorting">
                                <p-sortIcon field="companyName"></p-sortIcon>
                            </span>
                            <p-columnFilter [hidden]="!showFilters" type="text" field="companyName" display="menu" #filterCompanyName
                                [showAddButton]="false" [showOperator]="false"
                                [matchModeOptions]="matchModeOptions" [showClearButton]="false"
                                [showApplyButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <input #companyName type="text" value="{{filters?.companyName[0]?.value}}"
                                        pInputText class="pinputHeight">
                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                            (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                            (onClick)="filter(companyName.value);applyFilterNew(dt2);filterCompanyName.hide()">Apply
                                        </p-button>
                                    </div>
                                </ng-template>
                            </p-columnFilter>
                            
                        </th>
                        <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}"
                            *ngIf="isShowColumns('adminName')">Admin<span pSortableColumn="adminName"
                                *ngIf="showSorting">
                                <p-sortIcon field="adminName"></p-sortIcon>
                            </span>
                            <p-columnFilter [hidden]="!showFilters" type="text" display="menu" field="adminName" #filterAdminName
                                display="menu" [showAddButton]="false" [showOperator]="false"
                                [matchModeOptions]="matchModeOptions" [showClearButton]="false"
                                [showApplyButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <input #adminName type="text" value="{{filters?.adminName[0]?.value}}"
                                        pInputText class="pinputHeight">
                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                            (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                            (onClick)="filter(adminName.value);applyFilterNew(dt2);filterAdminName.hide()">Apply
                                        </p-button>
                                    </div>
                                </ng-template>
                            </p-columnFilter>
                            
                        </th>
                        <th pResizableColumn [ngStyle]="{'width':setColumnWidth(8)}"
                            *ngIf="isShowColumns('adminEmail')">Email <span pSortableColumn="adminEmail"
                                *ngIf="showSorting">
                                <p-sortIcon field="adminEmail"></p-sortIcon>
                            </span>
                            <p-columnFilter [hidden]="!showFilters" type="text" display="menu" field="adminEmail" #filterAdminEmail
                                display="menu" [showAddButton]="false" [showOperator]="false"
                                [matchModeOptions]="matchModeOptions" [showClearButton]="false"
                                [showApplyButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <input #adminEmail type="text" value="{{filters?.adminEmail[0]?.value}}"
                                        pInputText class="pinputHeight">
                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                            (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                            (onClick)="filter(adminEmail.value);applyFilterNew(dt2);filterAdminEmail.hide()">Apply
                                        </p-button>
                                    </div>
                                </ng-template>
                            </p-columnFilter>
                            
                        </th>
                        <th pResizableColumn [ngStyle]="{'width':setColumnWidth(8)}"
                            *ngIf="isShowColumns('adminPrimaryPhone')">Phone <span pSortableColumn="adminPrimaryPhone"
                                *ngIf="showSorting">
                                <p-sortIcon field="adminEmail"></p-sortIcon>
                            </span>
                            <p-columnFilter [hidden]="!showFilters" type="text" display="menu" field="adminPrimaryPhone" #filterAdminPrimaryPhone
                                display="menu" [showAddButton]="false" [showOperator]="false"
                                [matchModeOptions]="matchModeOptions" [showClearButton]="false"
                                [showApplyButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <input #adminPrimaryPhone type="text" value="{{filters?.adminPrimaryPhone[0]?.value}}"
                                        pInputText class="pinputHeight">
                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                            (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                            (onClick)="filter(adminPrimaryPhone.value);applyFilterNew(dt2);filterAdminPrimaryPhone.hide()">Apply
                                        </p-button>
                                    </div>
                                </ng-template>
                            </p-columnFilter>
                           
                        </th>
                        <th pResizableColumn [ngStyle]="{'width':setColumnWidth(6)}"
                                    *ngIf="isShowColumns('hasCompProfileCompleted')">Company<br>Profile
                                    <p-columnFilter [hidden]="!showFilters" type="text" field="hasCompProfileCompleted" display="menu" #filterHasCompProfileCompleted
                                        [showAddButton]="false" [showOperator]="false" [showClearButton]="false"
                                        [showApplyButton]="false" [matchModeOptions]="matchModeOptionsForDropdown">
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-dropdown #companyProfileStatus [options]="completionSearchValues"
                                                [(ngModel)]="selectedCompanyProfileStatusId"
                                                (onChange)="getCompanyProfileStatusOnChange($event)">
                                            </p-dropdown>
                                            <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                                    (onClick)="clearCompanyProfileStatus();filter(null);applyFilterNew(dt2);">Clear
                                                </p-button>
                                                <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                                    (onClick)="filter(companyProfileStatus.value);applyFilterNew(dt2);filterHasCompProfileCompleted.hide()">Apply
                                                </p-button>
                                            </div>
                                        </ng-template>
                                    </p-columnFilter>
                                    
                                </th>
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(6)}"
                                *ngIf="isShowColumns('hasCompDetailsCompleted')">Company<br>Details
                                <p-columnFilter [hidden]="!showFilters" type="text" field="hasCompDetailsCompleted" display="menu" #filterHasCompDetailsCompleted
                                    [showAddButton]="false" [showOperator]="false" [showClearButton]="false"
                                    [showApplyButton]="false" [matchModeOptions]="matchModeOptionsForDropdown">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-dropdown #companyDetailStatus [options]="completionSearchValues"
                                            [(ngModel)]="selectedCompanyDetailStatusId"
                                            (onChange)="getCompanyDetailStatusOnChange($event)">
                                        </p-dropdown>
                                        <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                                (onClick)="clearCompanyDetailStatus();filter(null);applyFilterNew(dt2);">Clear
                                            </p-button>
                                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                                (onClick)="filter(companyDetailStatus.value);applyFilterNew(dt2);filterHasCompDetailsCompleted.hide()">Apply
                                            </p-button>
                                        </div>
                                    </ng-template>
                                </p-columnFilter>
                               
                            </th>
                            <th pResizableColumn [ngStyle]="{'width':setColumnWidth(6)}"
                            *ngIf="isShowColumns('hasDeliveryTeamsCompleted')">Delivery<br>Teams
                            <p-columnFilter [hidden]="!showFilters" type="text" field="hasDeliveryTeamsCompleted" display="menu" #filterHasDeliveryTeamsCompleted
                                [showAddButton]="false" [showOperator]="false" [showClearButton]="false"
                                [showApplyButton]="false" [matchModeOptions]="matchModeOptionsForDropdown">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-dropdown #deliveryTeamStatus [options]="completionSearchValues"
                                        [(ngModel)]="selectedDeliveryTeamStatusId"
                                        (onChange)="getDeliveryTeamStatusOnChange($event)">
                                    </p-dropdown>
                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                            (onClick)="clearDeliveryTeamStatus();filter(null);applyFilterNew(dt2);">Clear
                                        </p-button>
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                            (onClick)="filter(deliveryTeamStatus.value);applyFilterNew(dt2);filterHasDeliveryTeamsCompleted.hide()">Apply
                                        </p-button>
                                    </div>
                                </ng-template>
                            </p-columnFilter>
                           
                        </th>
                        <th pResizableColumn [ngStyle]="{'width':setColumnWidth(7)}"
                                    *ngIf="isShowColumns('hasReferenceCompleted')">Reference
                                    <p-columnFilter [hidden]="!showFilters" type="text" field="hasReferenceCompleted" display="menu" #filterHasReferenceCompleted
                                        [showAddButton]="false" [showOperator]="false" [showClearButton]="false"
                                        [showApplyButton]="false" [matchModeOptions]="matchModeOptionsForDropdown">
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-dropdown #referenceStatus [options]="completionSearchValues"
                                                [(ngModel)]="selectedReferenceStatusId"
                                                (onChange)="getReferenceStatusOnChange($event)">
                                            </p-dropdown>
                                            <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                                    (onClick)="clearReferenceStatus();filter(null);applyFilterNew(dt2);">Clear
                                                </p-button>
                                                <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                                    (onClick)="filter(referenceStatus.value);applyFilterNew(dt2);filterHasReferenceCompleted.hide()">Apply
                                                </p-button>
                                            </div>
                                        </ng-template>
                                    </p-columnFilter>
                                    
                                </th>
                                <th pResizableColumn [ngStyle]="{'width':setColumnWidth(6)}"
                                *ngIf="isShowColumns('hasAdminDetailsCompleted')">Admin<br>Details
                                <p-columnFilter [hidden]="!showFilters" type="text" field="hasAdminDetailsCompleted" display="menu" #filterHasAdminDetailsCompleted
                                    [showAddButton]="false" [showOperator]="false" [showClearButton]="false"
                                    [showApplyButton]="false" [matchModeOptions]="matchModeOptionsForDropdown">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-dropdown #adminDetailStatus [options]="completionSearchValues"
                                            [(ngModel)]="selectedAdminDetailStatusId"
                                            (onChange)="getAdminDetailStatusOnChange($event)">
                                        </p-dropdown>
                                        <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                                (onClick)="clearAdminDetailStatus();filter(null);applyFilterNew(dt2);">Clear
                                            </p-button>
                                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                                (onClick)="filter(adminDetailStatus.value);applyFilterNew(dt2);filterHasAdminDetailsCompleted.hide()">Apply
                                            </p-button>
                                        </div>
                                    </ng-template>
                                </p-columnFilter>
                               
                            </th>
                            <th pResizableColumn [ngStyle]="{'width':setColumnWidth(11)}"
                            *ngIf="isShowColumns('hasOnboardDocsCompleted')">Onboarding Documents /<br>Client Selection
                            <p-columnFilter [hidden]="!showFilters" type="text" field="hasOnboardDocsCompleted" display="menu" #filterHasOnboardDocsCompleted
                                [showAddButton]="false" [showOperator]="false" [showClearButton]="false"
                                [showApplyButton]="false" [matchModeOptions]="matchModeOptionsForDropdown">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-dropdown #onboardingDocumentStatus [options]="completionSearchValues"
                                        [(ngModel)]="selectedOnboardingDocumentStatusId"
                                        (onChange)="getOnboardingDocumentStatusOnChange($event)">
                                    </p-dropdown>
                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                            (onClick)="clearOnboardingDocumentStatus();filter(null);applyFilterNew(dt2);">Clear
                                        </p-button>
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                            (onClick)="filter(onboardingDocumentStatus.value);applyFilterNew(dt2);filterHasOnboardDocsCompleted.hide()">Apply
                                        </p-button>
                                    </div>
                                </ng-template>
                            </p-columnFilter>
                            

                        </th>
                        <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}"
                            *ngIf="isShowColumns('createdOn')">Created On <span pSortableColumn="createdOn"
                                *ngIf="showSorting">
                                <p-sortIcon field="createdOn"></p-sortIcon>
                            </span>
                            <p-columnFilter [hidden]="!showFilters" type="date" field="createdOn" display="menu" #filterCreatedOn
                                [showAddButton]="showAddRuleButtonCO" [showOperator]="false"
                                [matchModeOptions]="matchModeOptionsForDate" [showClearButton]="false"
                                [showApplyButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-calendar #createdOn inputId="navigators" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" [ngModel]="value"></p-calendar>
                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                            (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                            (onClick)="filter(createdOn.value);applyFilterNew(dt2);filterCreatedOn.hide()">Apply
                                        </p-button>
                                    </div>
                                </ng-template>
                            </p-columnFilter>
                            
                        </th>
                        <th pResizableColumn [ngStyle]="{'width':setColumnWidth(9)}"
                            *ngIf="isShowColumns('modifiedOn')">Modified On <span pSortableColumn="modifiedOn"
                                *ngIf="showSorting">
                                <p-sortIcon field="modifiedOn"></p-sortIcon>
                            </span>
                            <p-columnFilter [hidden]="!showFilters" type="date" field="modifiedOn" display="menu" #filterModifiedOn
                                [showAddButton]="showAddRuleButtonMO" [showOperator]="false"
                                [matchModeOptions]="matchModeOptionsForDate" [showClearButton]="false"
                                [showApplyButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-calendar #modifiedOn inputId="navigators" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" [ngModel]="value"></p-calendar>
                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                            (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                            (onClick)="filter(modifiedOn.value);applyFilterNew(dt2);filterModifiedOn.hide()">Apply
                                        </p-button>
                                    </div>
                                </ng-template>
                            </p-columnFilter>
                           
                        </th>
                        <th pResizableColumn  [ngStyle]="{'width':setColumnWidth(8)}"*ngIf="isShowColumns('createdByName')">Created By <span pSortableColumn="createdByName" *ngIf="showSorting"><p-sortIcon field="createdByName"></p-sortIcon></span>
                            <p-columnFilter class="p-mr-4" [hidden]="!showFilters" type="text" field="createdByName" display="menu" #filterCreatedBy [showAddButton]="false" [showOperator]="false"  
                            [matchModeOptions]="matchModeOptions" [showClearButton]="false" [showApplyButton]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <input #createdByName type="text" value="{{filters?.createdByName[0]?.value}}" pInputText class="pinputHeight">
                                <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                    <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                    <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(createdByName.value);applyFilterNew(dt2);filterCreatedBy.hide()">Apply</p-button>
                                </div>
                            </ng-template>
                            </p-columnFilter>
                            
                        </th>
                        <!-- <th pResizableColumn  [ngStyle]="{'width':setColumnWidth(8)}"*ngIf="isShowColumns('modifiedByName')">Modified By <span pSortableColumn="modifiedByName" *ngIf="showSorting"><p-sortIcon field="modifiedByName"></p-sortIcon></span>
                            <p-columnFilter class="p-mr-4" *ngIf="showFilters" type="text" field="modifiedByName" display="menu" #filterModifiedBy [showAddButton]="false" [showOperator]="false"  
                            [matchModeOptions]="matchModeOptions" [showClearButton]="false" [showApplyButton]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <input #modifiedByName type="text" value="{{filters?.modifiedByName[0]?.value}}" pInputText class="pinputHeight">
                                <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                    <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                    <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(modifiedByName.value);applyFilterNew(dt2);filterModifiedBy.hide()">Apply</p-button>
                                </div>
                            </ng-template>
                            </p-columnFilter>
                            
                        </th> -->
                    </tr>
                    <tr [hidden]="!showFilters">
                        <th *ngIf="isShowColumns('companyName')">{{filters?.companyName[0]?.value}}</th>
                        <th *ngIf="isShowColumns('adminName')">{{filters?.adminName[0]?.value}}</th>
                        <th *ngIf="isShowColumns('adminEmail')">{{filters?.adminEmail[0]?.value}}</th>
                        <th *ngIf="isShowColumns('adminPrimaryPhone')">{{filters?.adminPrimaryPhone[0]?.value}}</th>
                        <th *ngIf="isShowColumns('hasCompProfileCompleted')">{{filters?.hasCompProfileCompleted[0]?.value}}</th>
                        <th *ngIf="isShowColumns('hasCompDetailsCompleted')">{{filters?.hasCompDetailsCompleted[0]?.value}}</th>
                        <th *ngIf="isShowColumns('hasDeliveryTeamsCompleted')">{{filters?.hasDeliveryTeamsCompleted[0]?.value}}</th>  
                        <th *ngIf="isShowColumns('hasReferenceCompleted')">{{filters?.hasReferenceCompleted[0]?.value}}</th>
                        <th *ngIf="isShowColumns('hasAdminDetailsCompleted')">{{filters?.hasAdminDetailsCompleted[0]?.value}}</th>
                        <th *ngIf="isShowColumns('hasOnboardDocsCompleted')">{{filters?.hasOnboardDocsCompleted[0]?.value}}</th>
                        
                        <th *ngIf="isShowColumns('createdOn')">{{filters?.createdOn[0]?.value |
                            date:'MM/dd/yyyy'}} <span *ngIf="filters?.createdOn.length > 1">-</span>
                            {{filters?.createdOn[1]?.value | date:'MM/dd/yyyy'}}</th>
                        <th *ngIf="isShowColumns('modifiedOn')">{{filters?.modifiedOn[0]?.value |
                            date:'MM/dd/yyyy'}} <span *ngIf="filters?.modifiedOn.length > 1">-</span>
                            {{filters?.modifiedOn[1]?.value | date:'MM/dd/yyyy'}}</th>
                            
                            <th *ngIf="isShowColumns('createdByName')">{{filters?.createdByName[0]?.value}}</th>
                            <!-- <th *ngIf="isShowColumns('modifiedByName')">{{filters?.modifiedByName?.value}}</th> -->


                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-vendorProfileStatusList>
                    <tr>

                        <td *ngIf="isShowColumns('companyName')"><span>{{vendorProfileStatusList.companyName}}</span>
                        </td>
                        <td *ngIf="isShowColumns('adminName')">
                            <span>{{vendorProfileStatusList.adminName}}</span>
                        </td>
                        <td *ngIf="isShowColumns('adminEmail')">
                            <span>{{vendorProfileStatusList.adminEmail}}</span>
                        </td>
                        <td *ngIf="isShowColumns('adminPrimaryPhone')">
                            <span>{{vendorProfileStatusList.adminPrimaryPhone | mask:'(000) 000-0000'}}</span>
                        </td>
                        <td *ngIf="isShowColumns('hasCompProfileCompleted')">
                            <span
                                *ngIf="(vendorProfileStatusList.hasCompProfileCompleted ==0 || vendorProfileStatusList.hasCompProfileCompleted ==null)">No</span>
                            <span
                                *ngIf="(vendorProfileStatusList.hasCompProfileCompleted == 1)"> Yes</span>
                        </td>
                        <td *ngIf="isShowColumns('hasCompDetailsCompleted')">
                            <span
                                *ngIf="(vendorProfileStatusList.hasCompDetailsCompleted ==0 || vendorProfileStatusList.hasCompDetailsCompleted ==null)">No</span>
                            <span
                                *ngIf="(vendorProfileStatusList.hasCompDetailsCompleted == 1)"> Yes</span>
                        </td>
                        <td *ngIf="isShowColumns('hasDeliveryTeamsCompleted')">
                            <span
                                *ngIf="(vendorProfileStatusList.hasDeliveryTeamsCompleted ==0 ||vendorProfileStatusList.hasDeliveryTeamsCompleted == null)">No</span>
                            <span
                                *ngIf="(vendorProfileStatusList.hasDeliveryTeamsCompleted == 1)"> Yes</span>
                        </td>
                        <td *ngIf="isShowColumns('hasReferenceCompleted')">
                            <span
                                *ngIf="(vendorProfileStatusList.hasReferenceCompleted ==0 || vendorProfileStatusList.hasReferenceCompleted == null )">No</span>
                            <span
                                *ngIf="(vendorProfileStatusList.hasReferenceCompleted == 1)"> Yes</span>
                        </td>
                        <td *ngIf="isShowColumns('hasAdminDetailsCompleted')">
                            <span
                                *ngIf="(vendorProfileStatusList.hasAdminDetailsCompleted ==0 || vendorProfileStatusList.hasAdminDetailsCompleted ==null)">No</span>
                            <span
                                *ngIf="(vendorProfileStatusList.hasAdminDetailsCompleted == 1)"> Yes</span>
                        </td>
                        <td *ngIf="isShowColumns('hasOnboardDocsCompleted')">
                            <span
                                *ngIf="(vendorProfileStatusList.hasOnboardDocsCompleted ==0 || vendorProfileStatusList.hasOnboardDocsCompleted ==null)">No</span>
                            <span
                                *ngIf="(vendorProfileStatusList.hasOnboardDocsCompleted == 1)"> Yes</span>
                        </td>
                        <td *ngIf="isShowColumns('createdOn')"><span>{{vendorProfileStatusList.createdOn |
                                date:'MM/dd/yyyy'}}</span></td>
                        <td *ngIf="isShowColumns('modifiedOn')"><span>{{vendorProfileStatusList.modifiedOn |
                                date:'MM/dd/yyyy'}}</span></td>
                                <td *ngIf="isShowColumns('createdByName')"><span>{{vendorProfileStatusList?.createdByName}} </span></td>
                                <!-- <td *ngIf="isShowColumns('modifiedByName')"><span>{{vendorProfileStatusList?.modifiedByName}}</span></td> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="selectedColumns.length">No Vendors found.</td>
                    </tr>
                </ng-template>
            </p-table>
            </div>
        </div>
    </div>
</div>
</section>